<template>
  <div>
    Display Image Recognition Here...
  </div>
</template>

<script>
export default {
  name: 'ImageRecognition',
  data: function () {
    return {
    }
  },
  computed: {
  },
  methods: { },
}
</script>

<style lang="scss" scoped>
</style>
